import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  ToolbarService,
  LinkService,
  ImageService,
  HtmlEditorService,
} from "@syncfusion/ej2-angular-richtexteditor";
import { TranslateService } from "@ngx-translate/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "src/app/Services/crud.service";
import { LoadingService } from "src/app/Services/loading.service";

@Component({
  selector: "app-workflow-translation",
  templateUrl: "./workflow-translation.component.html",
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService],
  standalone: false,
})
export class WorkflowTranslationComponent implements OnInit {
  @Input() data: string = "";
  @Input() stepName: string = "";
  @Input() placeholder: string = "";
  @Input() workflowData;
  @Input() mainWorkflow;
  /* : {
    primaryLanguage: {
      id: "";
      updatedAt: "";
      workflowStepType: "text" | "click";
      intro: "";
    };
    supportedLanguage: { id: ""; updatedAt: "" };
  }; */
  @Input() languageId;
  @Output() save = new EventEmitter<string>();

  @Input() languageList: any = [];
  isEditing: boolean = false;

  public toolbarSettings: object = {
    items: ["Bold", "Italic", "Underline", "Formats", "Undo", "Redo"],
  };

  constructor(
    private translateService: TranslateService,
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private crudService: CrudService,
    private loadingService: LoadingService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    if (!this.data && !this.stepName) {
      this.isEditing = true;
      this.data = "";
      this.stepName = "";
    }
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
  }
  saveEdit() {
    if (!this.stepName) {
      this.toastr.error("Step name required.", "Invalid Operation");
      return;
    }

    if (
      !this.data &&
      this.workflowData.primaryLanguage.workflowStepType === "text"
    ) {
      this.toastr.error("Text required.", "Invalid Operation");
      return;
    }

    var payload = {
      ...this.workflowData.primaryLanguage,
      // parentId: this.workflowData.primaryLanguage.id,
      name: this.stepName,
      intro:
        this.workflowData.primaryLanguage.workflowStepType === "text"
          ? this.data
          : this.workflowData.primaryLanguage.intro,
      languageId: this.languageId,
      id: null,
    };

    this.crudService.post(
      payload,
      (response) => {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          this.toastr.error(response.error.error.message, "Invalid Operation");
        } else {
          this.toastr.success(
            "Workflow step has been created successfully.",
            "Success"
          );
          this.save.emit();
          this.isEditing = false;
        }
      },
      // "workflow-steps"
      "currentWorkflowDetailsSteps"
    );
  }
}
